import React, { useState } from 'react';
import PostByAgg from '../utils/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ChangePassword = () => {
    // const [imagePreview, setImagePreview] = useState('assets/images/user-grid/user-grid-img13.png');
    const [existingPasswordVisible, setExistingPasswordVisible] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  
    const [existingPassword, setExistingPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();
    const { email } = useAuth()

    // Toggle function for password field
    const toggleExistingPasswordVisibility = () => {
        setExistingPasswordVisible((prev) => !prev);
    }
    const togglePasswordVisibility = () => {
        setPasswordVisible((prev) => !prev)
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible((prev) => !prev);
    };

    // const readURL = (input) => {
    //     if (input.target.files && input.target.files[0]) {
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             setImagePreview(e.target.result);
    //         };
    //         reader.readAsDataURL(input.target.files[0]);
    //     }
    // };

    const handleSave = (e) => {
        e.preventDefault();
        setError("");
        setSuccessMessage("");
    
        // Validasi
        if (!existingPassword || !password || !confirmPassword) {
          setError("Semua field wajib diisi.");
          return;
        }
    
        if (password !== confirmPassword) {
          setError("Password dan konfirmasi password harus sama.");
          return;
        }
    
        if (password.length < 8) {
          setError("Password harus minimal 8 karakter.");
          return;
        }
    
        if (!/[A-Z]/.test(password)) {
          setError("Password harus mengandung huruf kapital.");
          return;
        }
    
        if (!/[0-9]/.test(password)) {
          setError("Password harus mengandung angka.");
          return;
        }
    
        if (/\s/.test(password)) {
          setError("Password tidak boleh mengandung spasi.");
          return;
        }
    
        if (!email) {
            setError("Email tidak ditemukan. Silakan login ulang.");
            return;
        }

        PostByAgg({
            url: "user/um/v1/change-password",
            body: {
              email: email,
              old_password: existingPassword,
              new_password: password,
            },
            onResponse: (res) => {
              if (res.data.code === "2002000") {
                setSuccessMessage("Password berhasil diperbarui!");
                setError("");
                setExistingPassword("");
                setPassword("");
                setConfirmPassword("");
                navigate("/dashboard");
              } else {
                setError(res.data.message.id || "Gagal memperbarui password.");
              }
            },
            onError: (err) => {
              const msg = err?.response?.data?.message?.id || "Terjadi kesalahan.";
              setError(msg);
            },
          });

        // Simulasi submit
        console.log("Existing Password:", existingPassword);
        console.log("New Password:", password);
        setExistingPassword("");
        setPassword("");
        setConfirmPassword("");

    };
           



    return (
        <>
            <div className="row gy-4">
                <div className="col-lg-8 justify-content-center align-items-center">
                    <div className="card h-100">
                        <div className="card-body p-24">
                            <ul
                                className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                                id="pills-tab"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link d-flex align-items-center px-24 active"
                                        id="pills-change-passwork-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-change-passwork"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-change-passwork"
                                        aria-selected="true"
                                        // tabIndex={-1}
                                    >
                                        Change Password
                                    </button>
                                </li>
                                
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                                  <form onSubmit={handleSave}>
                                    <div className="mb-20">
                                        <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Existing Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={existingPasswordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="existing-password"
                                                placeholder="Enter New Password*"
                                                value={existingPassword}
                                               onChange={(e) => {
                                                   setExistingPassword(e.target.value);
                                                   setError('');
                                                   setSuccessMessage('');
                                               }}
                                            />
                                            <span
                                                className={`toggle-password ${!existingPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={toggleExistingPasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            New Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={passwordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="your-password"
                                                placeholder="Enter New Password*"
                                                value={password}
                                                onChange={(e) => {
                                                    setPassword(e.target.value);
                                                    setError('');
                                                    setSuccessMessage('');
                                                  }}
                                            />
                                            <span
                                                className={`toggle-password ${!passwordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={togglePasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    <div className="mb-20">
                                        <label htmlFor="confirm-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                            Confirm Password <span className="text-danger-600">*</span>
                                        </label>
                                        <div className="position-relative">
                                            <input
                                                type={confirmPasswordVisible ? "text" : "password"}
                                                className="form-control radius-8"
                                                id="confirm-password"
                                                placeholder="Confirm Password*"
                                                value={confirmPassword}
                                                onChange={(e) => {
                                                    setConfirmPassword(e.target.value);
                                                    setError('');
                                                    setSuccessMessage('');
                                                }}
                                            />
                                            <span
                                                className={`toggle-password ${!confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                                onClick={toggleConfirmPasswordVisibility}
                                            ></span>
                                        </div>
                                    </div>
                                    {/* Show error message */}
                    {error && <div className="alert alert-danger">{error}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                            <button
                                className="btn btn-primary w-42 rounded-lg hover-bg-primary py-12 px-32"
                                type="submit"
                                
                            >
                                Save
                            </button>
                                  </form>
                                </div>
                             
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default ChangePassword;